// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"74733ce5","444":"bb043ffc","514":"f35068ac","854":"5da5f62a","878":"28a9fb38"}[chunkId] + ".chunk.css";
};